import { useRef, useState } from "react";

type Props = { images: readonly string[]; name: string };

/** 카드 폭 300 + 간격 10 (Figma sec-character 356:1858). 스크롤 위치로 현재 장을 계산한다. */
const CARD_STEP = 310;

/**
 * 캐릭터 이미지 ≤5 가로 스크롤(scroll-snap). 0장이면 호출부가 coverUrl을 넣는다.
 * 시안(F02-04 · Ultra 펼침 동일): 300×400 카드, 첫 카드 우상단 "n / N" 카운터, 아래 도트(현재 16×6 brand, 나머지 6×6).
 */
export function CharacterCarousel({ images, name }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState(0);
  const onScroll = () => {
    const el = ref.current;
    if (!el) return;
    const next = Math.min(images.length - 1, Math.max(0, Math.round(el.scrollLeft / CARD_STEP)));
    if (next !== active) setActive(next);
  };
  return (
    <div className="plot__carousel-wrap">
      <div ref={ref} className="plot__carousel" data-testid="character-carousel" onScroll={onScroll}>
        {images.map((src, i) => (
          <img key={src + i} src={src} alt={i === 0 ? name : ""} loading={i === 0 ? "eager" : "lazy"} className="plot__carousel-img" onError={(e) => (e.currentTarget.style.visibility = "hidden")} />
        ))}
      </div>
      {images.length > 1 && (
        <>
          <span className="plot__carousel-counter" aria-live="polite" data-testid="carousel-counter">
            {active + 1} / {images.length}
          </span>
          <div className="plot__carousel-dots" aria-hidden="true" data-testid="carousel-dots">
            {images.map((_, i) => (
              <span key={i} className={i === active ? "plot__dot plot__dot--active" : "plot__dot"} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
